/**
 * SCROLL SNAP NAVIGATION
 * Simple JS for prev/next buttons with native scroll-snap
 */

(function() {
  'use strict';

  // Initialize all scroll containers on page load
  function initScrollNavigation() {
    // Handle tab navigation (Metalworking, Welding, etc)
    initTabsNavigation();

    // Handle collection carousels (products inside tabs)
    initCollectionsNavigation();

    // Handle tab switching
    initTabSwitching();
  }

  /**
   * TABS NAVIGATION (верхние табы)
   */
  function initTabsNavigation() {
    const tabsContainer = document.querySelector('.tabs-scroll-container');
    if (!tabsContainer) return;

    const sectionId = tabsContainer.id.replace('tabs-carousel-', '');
    const prevBtn = document.getElementById('tabs-button-prev-' + sectionId);
    const nextBtn = document.getElementById('tabs-button-next-' + sectionId);

    if (!prevBtn || !nextBtn) return;

    // Click handlers
    prevBtn.addEventListener('click', () => scrollTabs(tabsContainer, 'prev'));
    nextBtn.addEventListener('click', () => scrollTabs(tabsContainer, 'next'));

    // Update button states on scroll
    tabsContainer.addEventListener('scroll', () => updateButtonStates(tabsContainer, prevBtn, nextBtn));

    // Initial state
    updateButtonStates(tabsContainer, prevBtn, nextBtn);
  }

  function scrollTabs(container, direction) {
    const scrollAmount = container.clientWidth * 0.5; // Scroll half container width
    const newScrollLeft = direction === 'next'
      ? container.scrollLeft + scrollAmount
      : container.scrollLeft - scrollAmount;

    container.scrollTo({
      left: newScrollLeft,
      behavior: 'smooth'
    });
  }

  /**
   * COLLECTIONS NAVIGATION (карточки продуктов)
   */
  function initCollectionsNavigation() {
    const collectionContainers = document.querySelectorAll('.collections-scroll-container');

    collectionContainers.forEach(container => {
      const blockId = container.id.replace('collections-carousel-', '');
      const prevBtn = document.getElementById('collections-button-prev-' + blockId);
      const nextBtn = document.getElementById('collections-button-next-' + blockId);

      if (!prevBtn || !nextBtn) return;

      // Click handlers
      prevBtn.addEventListener('click', () => scrollCollections(container, 'prev'));
      nextBtn.addEventListener('click', () => scrollCollections(container, 'next'));

      // Update button states on scroll
      container.addEventListener('scroll', () => updateButtonStates(container, prevBtn, nextBtn));

      // Initial state
      updateButtonStates(container, prevBtn, nextBtn);
    });
  }

  function scrollCollections(container, direction) {
    const items = container.children;
    if (items.length === 0) return;

    const itemWidth = items[0].offsetWidth;
    const gap = 20; // Match CSS gap
    const scrollAmount = itemWidth + gap;

    const newScrollLeft = direction === 'next'
      ? container.scrollLeft + scrollAmount * 2 // Scroll 2 items
      : container.scrollLeft - scrollAmount * 2;

    container.scrollTo({
      left: newScrollLeft,
      behavior: 'smooth'
    });
  }

  /**
   * UPDATE BUTTON STATES (disabled/enabled)
   */
  function updateButtonStates(container, prevBtn, nextBtn) {
    const scrollLeft = container.scrollLeft;
    const maxScroll = container.scrollWidth - container.clientWidth;

    // Gray out prev button at start (keep visible, just gray)
    if (scrollLeft <= 5) {
      prevBtn.disabled = true;
      prevBtn.style.opacity = '1';
      prevBtn.style.pointerEvents = 'none';
    } else {
      prevBtn.disabled = false;
      prevBtn.style.opacity = '1';
      prevBtn.style.pointerEvents = 'auto';
    }

    // Gray out next button at end (keep visible, just gray)
    if (scrollLeft >= maxScroll - 5) {
      nextBtn.disabled = true;
      nextBtn.style.opacity = '1';
      nextBtn.style.pointerEvents = 'none';
    } else {
      nextBtn.disabled = false;
      nextBtn.style.opacity = '1';
      nextBtn.style.pointerEvents = 'auto';
    }

    // Hide both buttons if all content is visible (no scrolling needed)
    if (container.scrollWidth <= container.clientWidth + 2) {
      prevBtn.classList.add('hidden');
      nextBtn.classList.add('hidden');
    } else {
      prevBtn.classList.remove('hidden');
      nextBtn.classList.remove('hidden');
    }
  }

  /**
   * TAB SWITCHING (переключение между табами)
   */
  function initTabSwitching() {
    const tabLinks = document.querySelectorAll('.tabs-scroll-container a[role="tab"]');

    tabLinks.forEach(tab => {
      tab.addEventListener('click', function(e) {
        e.preventDefault();

        // Remove active and first class from all tabs
        tabLinks.forEach(t => {
          t.classList.remove('active', 'first');
          t.setAttribute('aria-selected', 'false');
        });

        // Add active and first class to clicked tab
        this.classList.add('active', 'first');
        this.setAttribute('aria-selected', 'true');

        // Show corresponding tab content
        const targetId = this.getAttribute('href').substring(1);
        // Only select tab content panels, NOT the tabs navigation itself
        const allPanels = document.querySelectorAll('.tab-body[role="tabpanel"]');

        allPanels.forEach(panel => {
          if (panel.id === targetId) {
            panel.classList.remove('hide');
            panel.setAttribute('tabindex', '0');

            // Re-initialize collections navigation for this tab
            const collectionsContainer = panel.querySelector('.collections-scroll-container');
            if (collectionsContainer) {
              const blockId = collectionsContainer.id.replace('collections-carousel-', '');
              const prevBtn = document.getElementById('collections-button-prev-' + blockId);
              const nextBtn = document.getElementById('collections-button-next-' + blockId);
              if (prevBtn && nextBtn) {
                setTimeout(() => updateButtonStates(collectionsContainer, prevBtn, nextBtn), 100);
              }
            }
          } else {
            panel.classList.add('hide');
            panel.setAttribute('tabindex', '-1');
          }
        });
      });
    });
  }

  /**
   * HANDLE WINDOW RESIZE
   */
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      // Re-check all button states on resize
      document.querySelectorAll('.tabs-scroll-container, .collections-scroll-container').forEach(container => {
        const containerId = container.id;
        let prevBtn, nextBtn;

        if (container.classList.contains('tabs-scroll-container')) {
          const sectionId = containerId.replace('tabs-carousel-', '');
          prevBtn = document.getElementById('tabs-button-prev-' + sectionId);
          nextBtn = document.getElementById('tabs-button-next-' + sectionId);
        } else {
          const blockId = containerId.replace('collections-carousel-', '');
          prevBtn = document.getElementById('collections-button-prev-' + blockId);
          nextBtn = document.getElementById('collections-button-next-' + blockId);
        }

        if (prevBtn && nextBtn) {
          updateButtonStates(container, prevBtn, nextBtn);
        }
      });
    }, 250);
  });

  /**
   * INITIALIZE ON LOAD
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollNavigation);
  } else {
    initScrollNavigation();
  }

  // Re-initialize on Shopify section load (theme editor)
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initScrollNavigation);
  }

})();
